import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import QRCode from "qrcode.react";

const DownloadFloatingComponent = () => {
  const { t, il8n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const links = [{
    icon: "/img/ug/floating/ios-icon.svg",
    link: "https://apps.apple.com/us/app/m4d/id6451379122",
    word: "APPLE_IOS"
  }, {
    icon: "/img/ug/floating/android-icon.svg",
    link: "https://play.google.com/store/apps/details?id=com.m4dresult.app",
    word: "ANDROID"
  }]

  const handleLinkOnClick = async (link) => {
    window.open(link, "_blank", "download-app")
  }

  return (
    <>
      <div className={`floating-download-container ${isOpen ? "expand" : ""}`} id="download-container">
        <div className="floating-download-inner-container" onMouseEnter={() => { setIsOpen(true); }} onMouseLeave={() => { setIsOpen(false); }}>
          <div className="floating-img-container">
            <img src="/img/ug/floating/download.svg" alt="download" className="floating-download-img" />
          </div>
          <div className="floating-text-container">
            <span className="floating-download-text">{t("DOWNLOAD")}</span>
          </div>
          <div className="floating-img-container-2">
            <img src="/img/ug/floating/left-arrow.svg" alt="left arrow" className="floating-download-img-2" />
          </div>
        </div>

        <div className="floating-download-hidden-container" onMouseEnter={() => { setIsOpen(true); }} onMouseLeave={() => { setIsOpen(false); }}>
          {links.map((item, index) => {
            return (
              <div key={index} className="floating-qr-container">
                <div className="floating-qr-img-container">
                  <QRCode value={item.link} />
                </div>
                <div className="floating-img-text-container" onClick={() => { handleLinkOnClick(item.link) }}>
                  <div className="floating-img-device-container">
                    <img src={item.icon} alt="" className="floating-device-img" />
                  </div>
                  <div className="floating-text-device-container">
                    <span className="floating-download-device">{t(item.word)}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default DownloadFloatingComponent;